import { Chip, Tooltip, Table, Card, TableBody, IconButton, TableContainer, TableHead, Typography, Paper, TableRow, FormControl, RadioGroup, FormControlLabel, Checkbox, Grid, Box, TextField, Select, InputLabel, MenuItem, Button, Divider, Radio, FormGroup } from '@mui/material';
import moment from 'moment';
import { styled } from '@mui/material/styles';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import { Add, AddCircleOutlineOutlined, CircleOutlined, ConstructionOutlined, PowerInputSharp, PropaneSharp, Visibility, Description, AddCircle } from '@mui/icons-material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import DeleteIcon from '@mui/icons-material/Delete';
import { readonlyContainerSx, readonlyTextFieldSx, readonlyTextFieldVariant } from '../../readonlyFieldStyles';
import {
    esConvenioDirecto,
    formatearCoeficiente,
    sanitizarCoeficienteInput,
    calcularSumaCoeficientes,
} from '../validaciones';

export default function DataImpuestos(props) {
    let nro_cuit = props.datos?.nro_cuit;
    const soloLectura = props.editar !== 1;
    const soloDetalle = Boolean(props.soloDetalle);
    const camposBloqueados = soloLectura || soloDetalle;
    const fieldVariant = soloLectura ? readonlyTextFieldVariant : "outlined";
    const fieldSx = soloLectura ? readonlyTextFieldSx : undefined;
    const docTipo6 = props.documentos.find(a => a.id_tipoadjunto === 6);
    const docTipo4 = props.documentos.find(a => a.id_tipoadjunto === 4);
    const today = new Date().toISOString().split("T")[0];
    const cicloFiscalActual = props.cicloFiscalActual;
    const esDirecto = esConvenioDirecto(props.datos?.id_convenio);
    const vigenciaCicloDate = cicloFiscalActual?.fecha_vto
        ? moment(cicloFiscalActual.fecha_vto).format("YYYY-MM-DD")
        : "";
    const vigenciaCicloDesde = vigenciaCicloDate
        ? `${moment(cicloFiscalActual.fecha_vto).format("YYYY")}-01-01`
        : "";
    const vigenciaCicloLabel = cicloFiscalActual?.fecha_vto
        ? moment(cicloFiscalActual.fecha_vto).format("DD/MM/YYYY")
        : "";
    const sumaCoeficientes = calcularSumaCoeficientes(
        props.regIIBBmanual,
        props.regIIBBpadron,
        { id_convenio: props.datos?.id_convenio }
    );
    const sumaCoefOk = sumaCoeficientes === 1;
    const sumaCoefLabel = sumaCoeficientes.toFixed(4).replace(".", ",");

    const deshacerAlmacenar = (index) => {
        const values = [...props.regIIBBmanual];
        values.splice(index, 1);
        if (index === 0 && props.regIIBBmanual.length === 1) {
            props.setregIIBBmanual([{
                nro_cuit: nro_cuit,
                retencion: esDirecto ? "1,0000" : "",
                coeficiente: esDirecto ? "1,0000" : "",
                vigencia_date: vigenciaCicloDate,
                id_provincia: "",
                fecha_vigencia_desde: vigenciaCicloDesde,
                porcentaje_exencion: "",
                vto_exencion: ""
            },
            ]);
        } else {
            props.setregIIBBmanual(values)
        }
    };

    const handleInputChange = (index, event) => {
        const values = [...props.regIIBBmanual];
        const updatedValue = event.target.name;
        let nextValue = event.target.value;

        if (updatedValue === "coeficiente" || updatedValue === "retencion") {
            if (esDirecto) {
                nextValue = "1,0000";
            } else {
                nextValue = sanitizarCoeficienteInput(nextValue, { permiteUno: false });
            }
            values[index].coeficiente = nextValue;
            values[index].retencion = nextValue;
        } else {
            values[index][updatedValue] = nextValue;
        }
        props.setregIIBBmanual(values);
    };

    const handlePadronIIBBExc = (index, event) => {
        const values = [...props.regIIBBpadron];
        const updatedValue = event.target.name;
        values[index][updatedValue] = event.target.value;
        props.setregIIBBpadron(values);
    };

    const removerExencion = (index) => {
        const values = [...props.regIIBBpadron];
        values[index].porcentaje_exencion = "";
        values[index].vto_exencion = "";
        props.setregIIBBpadron(values)
    };

    const almacenarImpuesto = () => {
        const values = [...props.regIIBBmanual];
        values.push({
            nro_cuit: nro_cuit,
            retencion: esDirecto ? "1,0000" : "",
            coeficiente: esDirecto ? "1,0000" : "",
            vigencia_date: vigenciaCicloDate,
            id_provincia: "",
            fecha_vigencia_desde: vigenciaCicloDesde,
            porcentaje_exencion: "",
            vto_exencion: ""
        })
        props.setregIIBBmanual(values);
    };

    const handleToggleOperacion = (operacion, isChecked) => {
        if (isChecked) {
            props.setOperacionesSeleccionadas(prev => [
                ...prev,
                {
                    id_operacion: operacion.id_operacion,
                    nro_cuit: nro_cuit,
                    usuario: localStorage.getItem('user'),
                    // Agregamos esto para evitar que el TextField rompa al buscar el valor
                    operacion_otros: ""
                }
            ]);
        } else {
            props.setOperacionesSeleccionadas(prev =>
                prev.filter(o => o.id_operacion !== operacion.id_operacion)
            );
        }
    };

    const StyledTableCell = styled(TableCell)(({ theme }) => ({
        [`&.${tableCellClasses.head}`]: {
            backgroundColor: "#3c4253ff",
            color: theme.palette.common.white,
            fontSize: 14,
            padding: 4
        },
        [`&.${tableCellClasses.body}`]: {
            fontSize: 14,
            padding: 5,
        },
    }));

    const StyledTableRow = styled(TableRow)(({ theme }) => ({
        '&:nth-of-type(odd)': {
            backgroundColor: "white",
        },
        '&:last-child td, &:last-child th': {
            border: 0,
        },
    }));

    console.log("props?.regIIBBpadron", props.regIIBBmanual)

    return (
        <>
            <Paper
                elevation={0}
                sx={{
                    borderRadius: 3,
                    backgroundColor: "#f4f6f8",
                    p: 1.5,
                    border: "1px solid #e0e6ed",
                    ...(soloLectura ? readonlyContainerSx : {}),
                }}
            >
                <Card variant="outlined" sx={{ p: 2, borderRadius: 2, borderLeft: '5px solid #1F618D', }}>
                    <Typography variant="button" sx={{ fontWeight: 700, color: "#1F618D" }}>
                        OPERACIONES
                    </Typography>
                    <Typography variant="body2"
                        sx={{
                            color: "text.secondary",
                            textAlign: { xs: "left", sm: "left" },
                            fontSize: {
                                xs: "0.9rem",
                                sm: "0.9rem",
                                md: "0.9rem",
                            },

                        }}>Tipo de operacion que efectua a fin de calculos retencion impuestos a las ganancias</Typography><Divider width="100%" />

                    <Grid container spacing={2}>
                        {
                            props.editar !== 1 ?
                                (
                                    <>
                                        {props.operacionesProveedor && props.operacionesProveedor.length > 0 ? props.operacionesProveedor?.map((op) => (
                                            <Grid item xs={12} sm={6} md={4} key={op.id_operacion} mr={3}>
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            checked
                                                            disabled
                                                        />
                                                    }
                                                    label={op.operacion}
                                                />
                                            </Grid>
                                        )) :
                                            <Grid item xs={12} sm={6} md={4} mr={3}>
                                                <Typography>No hay operaciones seleccionadas para este proveedor.</Typography>
                                            </Grid>}
                                    </>
                                )
                                :
                                (
                                    <>
                                        <Grid container spacing={2} mt={1}>
                                            {props.operaciones.map(opGeneral => {
                                                //    const selected= props.operacionesSeleccionadas?.includes(opGeneral.id_operacion);
                                                const selected = props.operacionesSeleccionadas?.find(
                                                    o => o.id_operacion === opGeneral.id_operacion
                                                );
                                                const isChecked = !!selected;

                                                return (
                                                    <Grid item xs={12} sm={6} md={4} key={opGeneral.id_operacion}>
                                                        <Box display="flex" alignItems="center" gap={1} flexWrap="wrap" ml={3}>

                                                            <FormControlLabel
                                                                control={
                                                                    <Checkbox
                                                                        checked={isChecked}
                                                                        onChange={(e) =>
                                                                            handleToggleOperacion(opGeneral, e.target.checked)
                                                                        }
                                                                    />
                                                                }
                                                                label={opGeneral.operacion}
                                                            />

                                                            {opGeneral.id_operacion === 5 && isChecked && (
                                                                <TextField
                                                                    label="Especifique otros"
                                                                    size="small"
                                                                    name="operacion_otros"
                                                                    value={selected?.operacion_otros || ""}
                                                                    onChange={(e) =>
                                                                        props.setOperacionesSeleccionadas(prev =>
                                                                            prev.map(o =>
                                                                                o.id_operacion === 5
                                                                                    ? { ...o, operacion_otros: e.target.value }
                                                                                    : o
                                                                            )
                                                                        )
                                                                    }
                                                                />
                                                            )}

                                                        </Box>
                                                    </Grid>
                                                );
                                            })}
                                        </Grid>

                                    </>
                                )
                        }
                    </Grid>
                </Card>

                <Card variant="outlined" sx={{ p: 2, borderRadius: 2, borderLeft: '5px solid #1F618D' }}>
                    <Grid size={{ xs: 12 }} sx={{ mb: 1 }}>
                        <Typography
                            variant="button" sx={{ fontWeight: 700, color: "#1F618D" }}
                        >
                            Ganancias
                        </Typography>
                        <Divider />
                    </Grid>

                    <Grid container spacing={2} alignItems="center">
                        {/* Sección Pregunta */}
                        <Grid item xs={12} md={4}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                <Typography fontWeight={500} sx={{ whiteSpace: 'nowrap' }}>
                                    ¿Posee exclusión?
                                </Typography>
                                <RadioGroup
                                    row
                                    name="exclusion"
                                    value={props.datos.exclusion?.toString()}
                                    onChange={camposBloqueados ? undefined : props.handleAlmacenarDatos}
                                >
                                    <FormControlLabel
                                        value="1"
                                        control={<Radio size="small" disabled={camposBloqueados} />}
                                        label="Sí"
                                    />
                                    <FormControlLabel
                                        value="0"
                                        control={<Radio size="small" disabled={camposBloqueados} />}
                                        label="No"
                                    />
                                </RadioGroup>
                            </Box>
                        </Grid>

                        {/* Sección Condicional: Se muestra solo si es "1" */}
                        {String(props.datos.exclusion) === "1" && (
                            <>
                                <Grid item xs={12} md={3}>
                                    <TextField
                                        type="date"
                                        name="vto_exclusion" // Importante para el onChange
                                        label="Vencimiento exclusión"
                                        fullWidth
                                        size="small"
                                        focused
                                        variant={fieldVariant}
                                        sx={fieldSx}
                                        value={props.datos.vto_exclusion}
                                        onChange={camposBloqueados ? undefined : props.handleAlmacenarDatos}
                                        InputProps={{
                                            readOnly: camposBloqueados,
                                        }}
                                        inputProps={{ min: today }}
                                    />
                                </Grid>

                                <Grid item xs={12} md={3}>
                                    <Button
                                        fullWidth
                                        variant="outlined"
                                        size="medium"
                                        startIcon={<Visibility />}
                                        onClick={() => {
                                            if (!docTipo4) {
                                                alert("No hay documento cargado");
                                                return;
                                            }
                                            props.editar !== 1 ? props.ViewFiles(docTipo4.nombre, docTipo4.extension) : props.abrirGestorAdjunto(4, "Exclusión ganancias")
                                        }}
                                        sx={{ textTransform: 'none' }}
                                    >
                                        VER ARCHIVO EXCLUSIÓN
                                    </Button>
                                </Grid>
                            </>
                        )}
                    </Grid>


                </Card>
                <Card variant="outlined" sx={{ p: 2, borderRadius: 2, borderLeft: '5px solid #1F618D', mb: 3 }}>
                    <Grid container alignItems="center" sx={{ mb: 2 }}>
                        <Typography variant="button" sx={{ fontWeight: 700, color: "#1F618D" }}>
                            Ingresos brutos
                        </Typography>
                    </Grid>

                    {props.editar === 1 ? (
                        <>
                            {props.regIIBBpadron?.length > 0 &&
                                <>
                                    <Divider sx={{ mb: 2 }} />
                                    <TableContainer component={Paper} variant="outlined" sx={{ mb: 2, bgcolor: '#f9f9f9' }}>
                                        <Table size="small">
                                            <TableHead sx={{ bgcolor: '#f0f0f0' }}>
                                                <TableRow>
                                                    <TableCell>Provincia</TableCell>
                                                    <TableCell align="center">Coeficiente</TableCell>
                                                    <TableCell>Vigencia</TableCell>
                                                    <TableCell align="center">% Exenc.</TableCell>
                                                    <TableCell>Vto. Exenc.</TableCell>
                                                    <TableCell align="right">Acciones</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {props.regIIBBpadron?.map((reg, index) => (
                                                    <TableRow key={`padron-${index}`}>
                                                        <TableCell><strong>{reg.provincia}</strong></TableCell>
                                                        <TableCell align="center">
                                                            {formatearCoeficiente(reg.coeficiente ?? reg.retencion, { esDirecto }) || "-"}
                                                        </TableCell>
                                                        <TableCell>
                                                            {reg.vigencia_date
                                                                ? moment(reg.vigencia_date).format("DD/MM/YYYY")
                                                                : (reg.fecha_vigencia_desde
                                                                    ? moment(reg.fecha_vigencia_desde).format("DD/MM/YYYY")
                                                                    : (vigenciaCicloLabel || "-"))}
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            <TextField
                                                                size="small"
                                                                type="number"
                                                                value={reg.porcentaje_exencion}
                                                                onChange={(e) => handlePadronIIBBExc(index, e)}
                                                                sx={{ width: '80px' }}
                                                            />
                                                        </TableCell>
                                                        <TableCell>
                                                            <TextField
                                                                size="small"
                                                                type="date"
                                                                value={reg.vto_exencion ? moment(reg.vto_exencion).format("YYYY-MM-DD") : ""}
                                                                onChange={(e) => handlePadronIIBBExc(index, e)}
                                                            />
                                                        </TableCell>
                                                        <TableCell align="right">
                                                            <Box display="flex" justifyContent="flex-end" gap={1}>
                                                                <Tooltip title="Ver IIBB"><IconButton size="small" onClick={() => props.abrirGestorAdjunto(6, "IIBB", reg.id_provincia)}><CloudUploadIcon fontSize="small" /></IconButton></Tooltip>
                                                                {reg.id_provincia === 1 && (
                                                                    <Tooltip title="Form. 1276"><IconButton size="small" color="primary" onClick={() => props.abrirGestorAdjunto(11, "Formulario 1276")}><Description fontSize="small" /></IconButton></Tooltip>
                                                                )}
                                                                <IconButton size="small" color="error" onClick={() => removerExencion(index)}><DeleteIcon fontSize="small" /></IconButton>
                                                            </Box>
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </>
                            }

                            <Divider sx={{ mb: 2 }} />

                            {props.regIIBBmanual?.map((field, index) => {
                                const provinciaValue =
                                    field.id_provincia !== "" && field.id_provincia != null
                                        ? Number(field.id_provincia)
                                        : "";
                                const provinciaExisteEnOpciones =
                                    provinciaValue === "" ||
                                    props.provincias.some((p) => Number(p.id) === provinciaValue);
                                const etiquetaProvinciaFallback =
                                    field.provincia || `Provincia ${provinciaValue}`;


                                return (
                                    <Paper variant="outlined" sx={{ p: 2, mb: 2, borderLeft: '4px solid #ed6c02' }} key={`manual-${index}`}>
                                        <Grid container spacing={2} alignItems="center">
                                            <Grid item xs={12} md={3}>
                                                <FormControl fullWidth size="small">
                                                    <InputLabel>Provincia</InputLabel>
                                                    <Select
                                                        label="Provincia"
                                                        value={provinciaValue}
                                                        onChange={(e) => {
                                                            handleInputChange(index, e);
                                                        }}
                                                        name="id_provincia"
                                                        disabled={!!field.id_provincia}
                                                    >
                                                        {!provinciaExisteEnOpciones && provinciaValue !== "" && (
                                                            <MenuItem value={provinciaValue}>
                                                                {etiquetaProvinciaFallback}
                                                            </MenuItem>
                                                        )}
                                                        {props.provincias.map((p) => (
                                                            <MenuItem
                                                                key={p.id}
                                                                value={Number(p.id)}
                                                                disabled={props.regIIBBmanual.some((item, itemIndex) => itemIndex !== index && Number(item.id_provincia) === Number(p.id))}>
                                                                {p.provincia} {p.iibb_auto === 1 ? "(Padrón)" : ""}
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                </FormControl>
                                            </Grid>
                                            <Grid item xs={6} md={1.5}>
                                                <TextField
                                                    label="Coeficiente"
                                                    size="small"
                                                    fullWidth
                                                    name="coeficiente"
                                                    value={
                                                        esDirecto
                                                            ? "1,0000"
                                                            : (field.coeficiente ?? field.retencion ?? "")
                                                    }
                                                    onChange={(e) => handleInputChange(index, e)}
                                                    disabled={esDirecto}
                                                    placeholder="0,0000"
                                                    inputProps={{ inputMode: "decimal" }}
                                                />
                                            </Grid>
                                            <Grid item xs={6} md={2}>
                                                <TextField
                                                    label="Vigencia"
                                                    size="small"
                                                    fullWidth
                                                    value={vigenciaCicloLabel}
                                                    disabled
                                                    InputLabelProps={{ shrink: true }}
                                                />
                                            </Grid>
                                            <Grid item xs={4} md={1.5}>
                                                <TextField label="% Exenc." size="small" fullWidth type="number" name="porcentaje_exencion" value={field.porcentaje_exencion} onChange={(e) => handleInputChange(index, e)} />
                                            </Grid>
                                            <Grid item xs={6} md={1.5}>
                                                <TextField label="Vto Exenc." size="small" fullWidth type="date" name="vto_exencion" focused value={field.vto_exencion || ""} onChange={(e) => handleInputChange(index, e)} required={field.porcentaje_exencion} />
                                            </Grid>
                                            <Grid item xs={12} md={2}>
                                                <Box
                                                    display="flex"
                                                    justifyContent="flex-end"
                                                    alignItems="center"
                                                    gap={0.5}
                                                >
                                                    <Tooltip title="Subir/Ver Archivo IIBB">
                                                        <span>
                                                            <IconButton
                                                                color="primary"
                                                                size="small"
                                                                onClick={() => props.abrirGestorAdjunto(6, "IIBB", field.id_provincia)}
                                                                disabled={!field.id_provincia}
                                                                sx={{
                                                                    border: '1px solid',
                                                                    borderColor: 'primary.main',
                                                                    '&.Mui-disabled': { border: '1px solid #e0e0e0' }
                                                                }}
                                                            >
                                                                <CloudUploadIcon fontSize="small" />
                                                            </IconButton>
                                                        </span>
                                                    </Tooltip>

                                                    {field.id_provincia === 1 && (
                                                        <Tooltip title="Form. 1276">
                                                            <IconButton
                                                                size="small"
                                                                color="info"
                                                                onClick={() => props.abrirGestorAdjunto(11, "Formulario 1276")}
                                                                sx={{ border: '1px solid', borderColor: 'info.main' }}
                                                            >
                                                                <Description fontSize="small" />
                                                            </IconButton>
                                                        </Tooltip>
                                                    )}

                                                    <Tooltip title="Eliminar jurisdicción">
                                                        <IconButton
                                                            color="error"
                                                            size="small"
                                                            onClick={() => deshacerAlmacenar(index)}
                                                        >
                                                            <DeleteIcon fontSize="small" />
                                                        </IconButton>
                                                    </Tooltip>

                                                    {index === props.regIIBBmanual.length - 1 && (
                                                        <Tooltip title="Agregar otra provincia">
                                                            <IconButton
                                                                color="success"
                                                                size="small"
                                                                onClick={() => almacenarImpuesto()}
                                                            >
                                                                <AddCircle fontSize="small" />
                                                            </IconButton>
                                                        </Tooltip>
                                                    )}
                                                </Box>
                                            </Grid>
                                        </Grid>
                                        <Typography variant="caption" color="text.secondary" sx={{ display: "block", mt: 1 }}>
                                            {esDirecto ? "Régimen directo: coeficiente 1,0000" : "Coeficiente: 0,0000 a 0,9999 con exactamente 4 decimales"}
                                        </Typography>
                                    </Paper>
                                )
                            })}
                            <Typography
                                variant="body2"
                                sx={{
                                    mt: 1,
                                    mb: 1,
                                    fontWeight: 600,
                                    color: sumaCoefOk ? "success.main" : "error.main",
                                }}
                            >
                                Suma de coeficientes: {sumaCoefLabel} {sumaCoefOk ? "(OK)" : "(debe ser 1,0000)"}
                            </Typography>
                        </>

                    ) : (
                        /* ================= VISTA ================= */
                        (() => {
                            const filasRevision = (props.iibbpadrones || []).map((ip) => {
                                const idProv = Number(ip.id_provincia);
                                const cat = props.provincias?.find((pr) => Number(pr.id) === idProv);
                                return {
                                    id: idProv,
                                    nombre: ip.provincia || cat?.provincia || `Provincia ${idProv}`,
                                    padron: ip,
                                };
                            });

                            if (filasRevision.length === 0) {
                                return (
                                    <Box sx={{ p: 3, textAlign: 'center', bgcolor: '#f5f5f5', borderRadius: 2, border: '1px dashed #ccc' }}>
                                        <Typography variant="body2" color="textSecondary">
                                            No hay datos de IIBB cargados.
                                        </Typography>
                                    </Box>
                                );
                            }

                            const celdaCoeficiente = (padron) => {
                                const v = padron?.coeficiente ?? padron?.retencion;
                                const formatted = formatearCoeficiente(v, { esDirecto: esConvenioDirecto(props.datos?.id_convenio) });
                                return formatted || "-";
                            };

                            const celdaVigencia = (padron) => {
                                if (padron?.vigencia_date != null && padron.vigencia_date !== "") {
                                    const m = moment(padron.vigencia_date);
                                    return m.isValid() ? m.format("DD/MM/YYYY") : String(padron.vigencia_date);
                                }
                                if (padron?.fecha_vigencia_desde) {
                                    const m = moment(padron.fecha_vigencia_desde);
                                    return m.isValid() ? m.format("DD/MM/YYYY") : "-";
                                }
                                return "-";
                            };

                            return (
                                <TableContainer
                                    sx={{
                                        maxHeight: 420,
                                        borderRadius: 2,
                                        "& th": { backgroundColor: "#EAF2F8" },
                                    }}
                                >
                                    <Table size="small" stickyHeader>
                                        <TableHead>
                                            <TableRow>
                                                <StyledTableCell>Provincia</StyledTableCell>
                                                <StyledTableCell align="center">Coeficiente</StyledTableCell>
                                                <StyledTableCell align="center">Vigencia</StyledTableCell>
                                                <StyledTableCell align="center">Exención</StyledTableCell>
                                                <StyledTableCell align="center">Vto. Exención</StyledTableCell>
                                                <StyledTableCell align="center">Certificados</StyledTableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {filasRevision.map((row) => {
                                                const { padron, id, nombre } = row;

                                                const archivoProvincia = props.documentos?.find(
                                                    (adj) =>
                                                        adj.id_tipoadjunto === 6 &&
                                                        Number(adj.id_provincia) === Number(id)
                                                );

                                                return (
                                                    <StyledTableRow key={id}>
                                                        <TableCell>{nombre}</TableCell>
                                                        <TableCell align="center">
                                                            {celdaCoeficiente(padron)}
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            {celdaVigencia(padron)}
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            {padron?.porcentaje_exencion > 0 ? `${padron.porcentaje_exencion}%` : "-"}
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            {padron?.vto_exencion
                                                                ? moment(padron.vto_exencion).format("DD/MM/YYYY")
                                                                : "-"}
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            {archivoProvincia ? (
                                                                <IconButton
                                                                    size="small"
                                                                    onClick={() => props.ViewFiles(archivoProvincia.nombre, archivoProvincia.extension)}
                                                                >
                                                                    <Visibility fontSize="small" />
                                                                </IconButton>
                                                            ) : "-"}
                                                        </TableCell>
                                                    </StyledTableRow>
                                                );
                                            })}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            );
                        })()
                    )}

                </Card>
            </Paper>
        </>
    )
}// <>
//     {/* ================= PADRON ================= */}
//     {props.regIIBBpadron && props.regIIBBpadron.map((reg, index) => (
//         console.log("reg", reg),

//         <Grid container spacing={2} key={`padron-${index}`}>
//             <Grid item xs={12} sm={6} md={2} mb={1}>
//                 <TextField
//                     label="Provincia"
//                     size="small"
//                     fullWidth
//                     focused
//                     disabled
//                     value={reg.provincia}
//                 />
//             </Grid>

//             <Grid item xs={12} sm={6} md={1}>
//                 <TextField
//                     label="% Retención"
//                     size="small"
//                     fullWidth
//                     type="number"
//                     focused
//                     disabled
//                     value={reg.retencion}
//                 />
//             </Grid>

//             <Grid item xs={12} sm={6} md={1.5}>
//                 <TextField
//                     label="Fecha vigencia desde"
//                     size="small"
//                     fullWidth
//                     focused
//                     disabled
//                     type="date"
//                     value={
//                         reg.fecha_vigencia_desde
//                             ? moment(reg.fecha_vigencia_desde).format("YYYY-MM-DD")
//                             : ""
//                     }
//                 />
//             </Grid>

//             <Grid item xs={12} sm={6} md={1}>
//                 <TextField
//                     label="% Exención"
//                     size="small"
//                     fullWidth
//                     focused
//                     name="porcentaje_exencion"
//                     type="number"
//                     value={reg.porcentaje_exencion}
//                     onChange={(e) => handlePadronIIBBExc(index, e)}
//                 />
//             </Grid>

//             <Grid item xs={12} sm={6} md={1.5}>
//                 <TextField
//                     label="Vto exención"
//                     size="small"
//                     fullWidth
//                     focused
//                     name="vto_exencion"
//                     type="date"
//                     value={
//                         reg.vto_exencion
//                             ? moment(reg.vto_exencion).format("YYYY-MM-DD")
//                             : ""
//                     }
//                     onChange={(e) => handlePadronIIBBExc(index, e)}
//                 />
//             </Grid>

//             <Grid item xs={12} sm={6} md={3}>
//                 <Button
//                     fullWidth
//                     disabled={!reg.id_provincia}
//                     variant="outlined"
//                     startIcon={<CloudUploadIcon />}
//                     // size="small"
//                     onClick={() => props.abrirGestorAdjunto(6, "IIBB", reg.id_provincia)}
//                 >
//                     Ver archivo IIBB
//                 </Button>
//             </Grid>
//             {reg.id_provincia === 1 ?
//                 <Grid item xs={12} sm={6} md={3}>
//                     <Button
//                         fullWidth
//                         variant="outlined"
//                         startIcon={<CloudUploadIcon />}
//                         // size="small"
//                         onClick={() => props.abrirGestorAdjunto(11, "Formulario 1276",)}
//                     >
//                         Formulario 1276
//                     </Button>
//                 </Grid>
//                 : null}
//             <Grid item xs>
//                 <Box display="flex" justifyContent="flex-end" gap={1}>
//                     <IconButton
//                         color="error"
//                         onClick={() => removerExencion(index)}
//                         size="small"
//                     >
//                         <DeleteIconIcon fontSize="small" />
//                     </IconButton>
//                 </Box>
//             </Grid>
//         </Grid>
//     ))}

//     {/* ================= MANUAL ================= */}
//     {props.provincias &&
//         props.regIIBBmanual?.map((field, index) => (

//             <Grid container spacing={2} mt={2} key={`manual-${index}`} >
//                 <Grid item xs={12} sm={6} md={2}>
//                     <FormControl fullWidth size="small">
//                         <Select
//                             disabled={!!field.id_provincia}
//                             variant="outlined"
//                             size="small"
//                             value={field.id_provincia}
//                             onChange={(e) => handleInputChange(index, e)}
//                             name="id_provincia"
//                         >
//                             {props.provincias.map((provincia) => {
//                                 const isDisabled = props.regIIBBmanual.some(
//                                     (item) => item.id_provincia === provincia.id
//                                 );

//                                 return (
//                                     <MenuItem
//                                         key={provincia.id}
//                                         value={provincia.id}
//                                         disabled={isDisabled}
//                                     >
//                                         {provincia.provincia}{" "}
//                                         {provincia.iibb_auto === 1 ? "(Padrón)" : ""}
//                                     </MenuItem>
//                                 );
//                             })}
//                         </Select>
//                     </FormControl>
//                 </Grid>

//                 <Grid item xs={12} sm={6} md={1}>
//                     <TextField
//                         label="% Retención"
//                         size="small"
//                         fullWidth
//                         type="number"
//                         focused
//                         required={field.id_provincia}
//                         name="retencion"
//                         value={field.retencion}
//                         onChange={(e) => handleInputChange(index, e)}
//                     />
//                 </Grid>

//                 <Grid item xs={12} sm={6} md={1.5}>
//                     <TextField
//                         label="Fecha vigencia desde"
//                         size="small"
//                         fullWidth
//                         focused
//                         name="fecha_vigencia_desde"
//                         required={field.id_provincia}
//                         type="date"
//                         value={field.fecha_vigencia_desde || ""}
//                         onChange={(e) => handleInputChange(index, e)}
//                     />
//                 </Grid>

//                 <Grid item xs={12} sm={6} md={1}>
//                     <TextField
//                         label="% Exención"
//                         size="small"
//                         fullWidth
//                         focused
//                         name="porcentaje_exencion"
//                         type="number"
//                         value={field.porcentaje_exencion}
//                         onChange={(e) => handleInputChange(index, e)}
//                     />
//                 </Grid>

//                 <Grid item xs={12} sm={6} md={1.5}>
//                     <TextField
//                         label="Vto exención"
//                         size="small"
//                         fullWidth
//                         focused
//                         name="vto_exencion"
//                         type="date"
//                         value={field.vto_exencion || ""}
//                         onChange={(e) => handleInputChange(index, e)}
//                     />
//                 </Grid>

//                 <Grid item xs={12} sm={6} md={2}>
//                     <Button
//                         fullWidth
//                         variant="outlined"
//                         startIcon={<CloudUploadIcon />}
//                         disabled={!field.id_provincia}
//                         onClick={() => props.abrirGestorAdjunto(6, "IIBB", field.id_provincia)}
//                     >
//                         Ver archivo IIBB
//                     </Button>
//                 </Grid>
//                 {field.id_provincia === 1 ?
//                     <Grid item xs={12} sm={6} md={2}>
//                         <Button
//                             fullWidth
//                             variant="outlined"
//                             startIcon={<CloudUploadIcon />}
//                             // size="small"
//                             onClick={() => props.abrirGestorAdjunto(11, "Formulario 1276",)}
//                         >
//                             Formulario 1276
//                         </Button>
//                     </Grid>
//                     : null}
//                 <Grid item xs>
//                     <Box display="flex" justifyContent="flex-end" gap={1}>
//                         <IconButton
//                             color="error"
//                             onClick={() => deshacerAlmacenar(index)}
//                             size="small"
//                         >
//                             <DeleteIconIcon fontSize="small" />
//                         </IconButton>

//                         {index === props.regIIBBmanual.length - 1 && (
//                             <IconButton
//                                 color="success"
//                                 onClick={() => almacenarImpuesto()}
//                                 size="small"
//                             >
//                                 <AddCircleOutlineOutlined fontSize="small" />
//                             </IconButton>
//                         )}
//                     </Box>
//                 </Grid>
//             </Grid>
//         ))}


// </>   // const handleToggleOperacion = (operacion, isChecked) => {
//     if (isChecked) {
//         props.setOperacionesSeleccionadas(prev => [
//             ...prev,
//             { id_operacion: operacion.id_operacion, nro_cuit: nro_cuit, usuario: localStorage.getItem('user') }
//         ]);
//     } else {
//         props.setOperacionesSeleccionadas(prev =>
//             prev.filter(o => o.id_operacion !== operacion.id_operacion)
//         );
//     }
// };
